import Stack from '@mui/material/Stack';
import { alpha, useTheme } from '@mui/material/styles';
import { bgGradient } from '@mgm/common/utils';

import { TCustomTheme } from '@mgm/common/theme';
import { FC } from 'react';
import { BaseHeader } from '@mgm/common/components/base';

type TAuthBackgroundLayout = {
  children: React.ReactNode;
};

const AuthBackgroundLayout: FC<TAuthBackgroundLayout> = ({ children }) => {
  const theme = useTheme() as TCustomTheme;

  return (
    <>
      <BaseHeader />

      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          ...bgGradient({
            color: alpha(theme.palette.background.default, 0.9),
            imgUrl: '/static/overlay_1.png',
          }),
          px: 2,
          py: 12,
          minHeight: '100vh',
        }}
      >
        <Stack
          spacing={4}
          sx={{
            p: 4,
            width: 1,
            mx: 'auto',
            flexShrink: 0,
            maxWidth: 500,
            borderRadius: 2,
            bgcolor: 'background.default',
            boxShadow: theme.customShadows.z24,
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          {children}
        </Stack>
      </Stack>
    </>
  );
};

export {
  AuthBackgroundLayout,
};
